module Easypass {
    angular.module('easypass').filter('shortMonth', [() => {
        return (month: number): string => {
            return `ShortMonth${month + 1}`;
        };
    }]);
}